import { Avatar } from '@calendly/ui/components/avatar';
import { BrandLogo } from '@calendly/ui/components/brand-logo';
import { FullStoryExclude } from '@calendly/ui/components/fullstory-privacy';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getPreferredContactName } from 'shared/utils/get_contact_display_name';
import { getInitials } from 'shared/utils/get_initials';
import { getNonContactRecipientInitial, shouldShowGmailBrandmarkForNonContact, shouldUseBlankAvatarForNonContact } from 'shared/utils/non_contact_recipient';
const avatarWrapperCss = "abl9rxl";
const AvatarWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(avatarWrapperCss, props.className)} />;
});
const gmailBrandmarkCss = "g1tkcxic";
const gmailBrandLogoCss = "gnnum9n";
const GmailBrandLogo = forwardRef((props, ref) => <BrandLogo ref={ref} {...props} name="gmail" title="Gmail" className={classNames(gmailBrandLogoCss, props.className)} />);
const GmailBrandmark = forwardRef((props, ref) => <span ref={ref} {...props} className={classNames(gmailBrandmarkCss, props.className)}>
    <GmailBrandLogo />
  </span>);
export const ContactRecipientAvatar = ({
  contact,
  size,
  isNonContactUiEnabled = false,
  showGmailBrandmark = false
}) => {
  if (isNonContactUiEnabled && shouldUseBlankAvatarForNonContact(contact)) {
    const avatar = <FullStoryExclude>
        <Avatar size={size} letter={getNonContactRecipientInitial(contact?.email)} />
      </FullStoryExclude>;
    if (shouldShowGmailBrandmarkForNonContact(contact)) {
      return <AvatarWrapper>
          {avatar}
          <GmailBrandmark />
        </AvatarWrapper>;
    }
    return avatar;
  }
  const preferredName = getPreferredContactName(contact);
  if (!preferredName) {
    return null;
  }
  const avatar = <FullStoryExclude>
      <Avatar src={contact.previewUrl} letter={getInitials(preferredName)} size={size} />
    </FullStoryExclude>;
  if (!showGmailBrandmark) {
    return avatar;
  }
  return <AvatarWrapper>
      {avatar}
      <GmailBrandmark />
    </AvatarWrapper>;
};

require("./contact_recipient_avatar.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./contact_recipient_avatar.js");